module.exports = __webpack_public_path__ + "static/media/BoxAbout.2584cda6.svg";